import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Trailer } from '@models/trailer.model';

export const adapter: EntityAdapter<Trailer> = createEntityAdapter<Trailer>({
    selectId: trailer => trailer.id
});

export interface State extends EntityState<Trailer> {
    loading: boolean;
    error?: any;
    total: number;
}

export const initialState: State = adapter.getInitialState({
    loading: false,
    error: null,
    total: 0
});
